import formMapper from "@mappers/Modules/media/MediaItem.mapper";
import createItemAPI from "@services/Media/createMedia";
import Create from "@shared/FormTemplates/Create";
import validator from "@validators/Modules/media/media.validate";
import { ReactElement } from "react";
import CreateForm from "./CreateMedia";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createItemAPI}
    validator={validator}
    formMapper={formMapper}
  />
);

export default CreateItem;
